import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseTableComponent } from '../base-table/base-table.component';
import { HelpboxService } from 'src/app/services/helpbox.service';
import { AlertService } from 'src/app/services/alert.service';
import { fuseAnimations } from '@mobileia/layout-fuse';

@Component({
  selector: 'app-helpbox',
  templateUrl: './helpbox.component.html',
  styleUrls: ['./helpbox.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class HelpboxComponent extends BaseTableComponent<any> implements OnInit {

  displayedColumns = ['id', 'title', 'actions'];
  configColumns = [
    {
      key: 'id',
      field_key: 'id',
      type: 'integer',
      title: 'ID',
      classes: 'font-weight-600'
    },
    {
      key: 'title',
      field_key: 'title',
      type: 'string',
      title: 'Titulo',
      classes: ''
    },
  ];

  constructor(
    protected helpService: HelpboxService,
    protected alertService: AlertService
  ) {
    super(alertService);
    this.service = helpService;
  }

  ngOnInit(): void {
    this.loadItems();
  }

}
